import * as React from 'react'

import { styled } from '../../../common/ui'
import { ArrowForwardIcon } from '../icons'
import { theme } from '../theme'

export const SubmitButtonContainer = styled.button<{ variant?: string }>`
  padding: 14px 31px;
  text-transform: uppercase;
  color: ${props =>
    props.variant === 'white' ? theme.colors.white : theme.colors.white};
  background: ${props =>
    props.variant === 'white' ? theme.colors.purpleDark : theme.colors.blue};

  font-weight: bold;
  font-size: 22px;
  border: ${props => (props.variant === 'white' ? '0px solid white' : '0')};
  cursor: pointer;
  &:hover {
    background: ${props =>
      props.variant === 'white' ? theme.colors.black : theme.colors.blueDark};
  }
  &:focus,
  &:active {
    outline: ${theme.outline};
  }
  &:disabled {
    cursor: not-allowed;
    color: #b8b8b8;
    background: #cecece;
    svg {
      path {
        fill: gray;
      }
    }
  }
`

export class SubmitButton extends React.Component<
  {
    text: React.ReactNode
    onClick?: (e: React.MouseEvent) => void
    disabled?: boolean
    variant?: string
  },
  {}
> {
  public render() {
    const { text, onClick, disabled, variant } = this.props
    return (
      <SubmitButtonContainer
        disabled={disabled}
        type="submit"
        onClick={onClick}
        variant={variant}
      >
        <span>{text}</span>
        <ArrowForwardIcon
          style={{ marginLeft: 15 }}
          fill={variant === 'white' ? theme.colors.white : theme.colors.white}
          w={26}
          h={26}
        />
      </SubmitButtonContainer>
    )
  }
}
